import { AES } from 'crypto-js';
import Css from "./MasterAdminNavbar.css";
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getBrandLogo, getBrandLogoAlt } from "../../../utils/brandLogo";
// import Notification from "../../Notification/Notification";
import React, { useState, useEffect, useRef } from "react";
import user_profile from "../../../images/user/Default_pfp.png";
import { setHeaderText } from "../../../features/headerText/headerTextSlice";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
import { resetAccountDetails } from "../../../features/accountDetails/accountDetailsSlice.js";
import Pusher from 'pusher-js';
import userCategory from '../../../constants/userCategory.js';
import InactivityHandler from "./InactivityHandler.jsx";
import Sidebar from "../../Sidebar/Sidebar.jsx"
import MasterSidebar from '../Sidebar/Sidebar.jsx';
import { masterLogout, reset } from '../../../features/masterAuth/masterAuthSlice.js';
import Modal from "react-modal";

const MasterAdminNavbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const masterUser = useSelector((state) => state.masterAuth);
  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [dashboardText, setDashboardText] = useState("");
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const profileImage = masterUser?.masterUser?.profile_image || "";
  const userSectionRef = useRef(null);
  const headerText = useSelector(
    (state) => state.headerText.headerTextState
  );
  const { appSettings } = useSelector((state) => state.appSettings);
  const masterUserId = useSelector((state) => state.masterAuth.masterUser._id);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setIsActive(!isActive);
    dispatch(resetAccountDetails());
  };

  const profileSetting = () => {
    dispatch(setHeaderText("Profile Settings"));
    localStorage.setItem('activeTab', '0');
    setIsOpen(false);
  };

    
  useEffect(() => {

    // Initialize Pusher with your app key and cluster



    const pusher = new Pusher('77dbc32bce6ebdabdbc8', {
      cluster: 'ap1',
      encrypted: true,
    });

    // Subscribe to the channel and event you used in the backend
    const channel = pusher.subscribe(masterUserId);
    channel.bind('userLogout', (data) => {

      localStorage.removeItem("masterUser");
      dispatch(masterLogout());
      dispatch(reset());
      dispatch(invoiceReset());
      dispatch(headerReset());
      dispatch(appSettingsReset());
      document.body.classList.remove('open-menu-mob');
      window.location.reload();

    });

    channel.bind('userRefresh', (data) => {
      window.location.reload();
    });

    const channel2 = pusher.subscribe('allUsers');

    channel2.bind('forceLogout', (data) => {
      localStorage.removeItem("masterUser");
      dispatch(masterLogout());
      dispatch(reset());
      dispatch(invoiceReset());
      dispatch(headerReset());
      dispatch(appSettingsReset());
      document.body.classList.remove('open-menu-mob');
      window.location.reload();

    });

    channel2.bind('forceReload', (data) => {
      window.location.reload();
    });

    // Cleanup on unmount
    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
  }, []);


  useEffect(() => {
    const handleBodyClick = (event) => {
      if (userSectionRef.current && !userSectionRef.current.contains(event.target)) {
        setIsOpen(false);
        setIsActive(false);
        document.body.classList.remove("open-menu-mob");
      }
    };
    document.body.addEventListener("click", handleBodyClick);
    return () => {
      document.body.removeEventListener("click", handleBodyClick);
    };
  }, []);

  useEffect(() => {
    if (isActive) {
      document.body.classList.add("open-menu-mob");
    } else {
      document.body.classList.remove("open-menu-mob");
    }
  }, [isActive]);

  useEffect(() => {
    if (headerText) {
      setDashboardText(headerText);
    }
  }, [headerText]);

  return (
    <div className='navbar-outer'>
      <div className='navbar-inner'>
        <div className='navbar-lf'>
          {/* <h1 className='logo-main-nav-text-m11'>{global.config.locate(appSettings && appSettings.language, dashboardText)}</h1> */}
          <h1 className='logo-main-nav-text-m11'>{dashboardText}</h1>
          <img className='image-for-mob-only-nav1' src={getBrandLogo()} alt={getBrandLogoAlt()} />
        </div>
        <div className="navbar-rt">
          {/* {masterUser.masterUser.is_notification_enabled === true && (masterUser && (masterUser.masterUser.userCategory !== userCategory.Vendor) && (user.user.userCategory !== userCategory.Client)) && (
            <div className="nav-noti">
              <Notification />
            </div>
          )} */}
          <div className={`user-sec ${isActive ? "active" : ""}`} ref={userSectionRef}>
            <div className="user-inner">
              <div className="user-img" onClick={toggleDropdown}>
                {masterUser.isLoading ? (
                  <img src={user_profile} alt="User" />
                ) : (
                  <>
                    {profileImage && profileImage !== "null" ? (
                      <img
                        src={`/uploads/orgiProfileImage/${profileImage}`}
                        alt="User"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = user_profile;
                        }}
                      />
                    ) : (
                      <img src={user_profile} alt="User" />
                    )}
                  </>
                )}
              </div>
              {isOpen && (
                <div className="inner-profile">
                  <div className="mobile-menu-new">
                    <MasterSidebar />
                  </div>
                  <Link to="/master-user/profile/settings" onClick={profileSetting}>
                    {global.config.locate(appSettings && appSettings.language, 'Profile_Settings')}
                  </Link>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpen(false);
                      setLogoutModalOpen(true);
                    }}
                  >
                    {global.config.locate(appSettings && appSettings.language, 'Logout')}
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="delete-modal"
        isOpen={logoutModalOpen}
        onRequestClose={() => setLogoutModalOpen(false)}
        contentLabel="Confirm Logout"
        style={{
          content: {
            height: "41%",
            width: "30%",
            position: "fixed",
            top: "36%",
            left: "50%",
          },
        }}
      >
        <div className="delete-modal-content">
          <h2>Confirm Logout</h2>
          <p>Are you sure you want to log out?</p>
          <div className="delete-modal-buttons">
            <button
              type="button"
              className="buttons-rejected"
              onClick={() => {
                localStorage.removeItem("masterUser");
                dispatch(masterLogout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                navigate("/master-user/login");
              }}
            >
              Log Out
            </button>
            <button type="button" onClick={() => setLogoutModalOpen(false)}>
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <InactivityHandler />
    </div>

  );
};

export default MasterAdminNavbar;